module.exports = __webpack_public_path__ + "img/globe-nav-chevron-right-dent-red.39642cd5.svg";